import script from "./join-us.vue?vue&type=script&setup=true&lang=js"
export * from "./join-us.vue?vue&type=script&setup=true&lang=js"

import "./join-us.vue?vue&type=style&index=0&id=6a464664&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a464664"]])

export default __exports__